import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getGqlFragmentName, getSingleProp } from 'src/lib/graphql';

/**
 * Queries the result object of a job using passed GraphQL fragment
 * @param {string} id - ID of the job
 * @param {DocumentNode} gqlFragment - GraphQL fragment to use for the result object
 * @param {object} [options] - request options
 * @param {boolean} [options.list] - should we fetch "list" or "single object" result
 * @returns {Promise<object>} - The result object of the job
 */
export const queryJobResult = async (id, gqlFragment, options) => {
  const fragmentName = getGqlFragmentName(gqlFragment);
  if (!fragmentName) {
    throw new Error('GQL fragment must have a name when used in "queryJobResultObject"');
  }

  const isListResult = options?.list || false;
  const query = gql`
    query JobEntityResult($id: ID!) {
      jobStatus(id: $id) {
        id
        ${isListResult ? 'resultList' : 'resultObject'} {
          ...${fragmentName}
        }
      }
    }
    ${gqlFragment}
  `;

  const response = await executeGqlQuery({
    query,
    variables: { id },
  });

  const result = getSingleProp(response.data);
  return isListResult ? result?.resultList : result?.resultObject;
};
